import React from "react";
import { StyleSheet, View, Dimensions } from "react-native";
import { isWeb } from "../../../helpers/utils";
import AppConfig from "../../../config/AppConfig";

import Footer from "../common/footer";
import Header from "../common/header";
import appStyles from "../../appStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default class AppointmentPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;
  }

  render() {
    const Element = "div";
    const src = AppConfig.GUIDANCE_LINK;

    const width = isWeb ? Math.min(WIDTH, AppConfig.MAX_WIDTH) : WIDTH;
    const height = HEIGHT - 160;
    const code = `<iframe src=${src} frameBorder=0 width=${width} height=${height} />`;

    return (
      <View style={appStyles.container}>
        <Header
          title="Time Habits Survey"
          subTitle="Give us some context to provide custom insights"
          returnPage="rn:more"
          hideAvatar
          controller={this.controller}
        />

        <View style={{ justifyContent: "center" }}>
          <Element
            src={null}
            children={null}
            dangerouslySetInnerHTML={{ __html: code }}
          />
        </View>

        {this.controller.hasNavigation() ? null : (
          <View style={styles.footerOptions}>
            <Footer controller={this.controller} selectedPage="" />
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  iframe: {
    border: 0,
  },
  scrollView: {
    maxHeight: HEIGHT - 130,
  },
  footerOptions: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
});
